import Chevron from 'components/Chevron';
import { ReactNode, useState } from 'react';

interface MenuSectionProps {
  title: ReactNode;
  children: ReactNode;
  expanded?: boolean;
  onToggle?: (next: boolean) => void;
}

export default function Collapsible({
  title,
  children,
  expanded,
  onToggle,
}: MenuSectionProps) {
  const [internalExpanded, setInternalExpanded] = useState(false);

  const isControlled = expanded !== undefined && onToggle !== undefined;
  const isExpanded = isControlled ? expanded : internalExpanded;

  const handleToggle = () => {
    if (isControlled) {
      onToggle(!expanded);
    } else {
      setInternalExpanded((prev) => !prev);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div
        onClick={handleToggle}
        aria-expanded={isExpanded}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          cursor: 'pointer',
        }}
      >
        <div>{title}</div>
        <Chevron direction="down" reversed={isExpanded} />
      </div>
      {isExpanded && <div>{children}</div>}
    </div>
  );
}
